export const tools = [
    {
        name: 'identity_Invitations_list',
        description: "Open and recent invitations into the caller's tenant.",
        context: 'identity',
        operationId: 'Invitations_list',
        method: 'GET',
        path: '/invitations',
        action: 'invitation:list',
        auth: 'tenant',
        inputSchema: {
            type: 'object',
            properties: {
                query: {
                    type: 'object',
                    properties: {
                        cursor: {
                            type: 'string',
                        },
                        limit: {
                            type: 'integer',
                            format: 'int32',
                            minimum: 1,
                            maximum: 200,
                            default: 50,
                        },
                        status: {
                            type: 'string',
                            enum: ['pending', 'accepted', 'revoked', 'expired'],
                        },
                    },
                    required: [],
                    additionalProperties: false,
                },
            },
            required: [],
            additionalProperties: false,
        },
    },
    {
        name: 'identity_Invitations_create',
        description: 'Invite someone into the tenant. Creates the user with a temporary password and emails them.',
        context: 'identity',
        operationId: 'Invitations_create',
        method: 'POST',
        path: '/invitations',
        action: 'invitation:create',
        auth: 'tenant',
        inputSchema: {
            type: 'object',
            properties: {
                body: {
                    type: 'object',
                    required: ['email', 'roles'],
                    properties: {
                        email: {
                            type: 'string',
                        },
                        roles: {
                            type: 'array',
                            items: {
                                type: 'string',
                                enum: ['PlatformAdmin', 'TenantAdmin', 'Manager', 'Agent'],
                                description: 'Roles as carried in the JWT `cognito:groups` claim and the memberships table.',
                            },
                        },
                        officeCode: {
                            type: 'string',
                            pattern: '^[A-Z0-9][A-Z0-9-]{0,31}$',
                            description: 'Office code inside a tenant.',
                        },
                        agentCode: {
                            type: 'string',
                            pattern: '^[A-Z0-9][A-Z0-9-]{0,31}$',
                            description: 'Agent code inside a tenant.',
                        },
                    },
                },
            },
            required: ['body'],
            additionalProperties: false,
        },
    },
    {
        name: 'identity_Invitations_get',
        description: 'One invitation.',
        context: 'identity',
        operationId: 'Invitations_get',
        method: 'GET',
        path: '/invitations/{invitationId}',
        action: 'invitation:read',
        auth: 'tenant',
        inputSchema: {
            type: 'object',
            properties: {
                params: {
                    type: 'object',
                    properties: {
                        invitationId: {
                            type: 'string',
                            pattern: '^[0-9A-HJKMNP-TV-Z]{26}$',
                            description: 'ULID-style opaque identifier for records.',
                        },
                    },
                    required: ['invitationId'],
                    additionalProperties: false,
                },
            },
            required: ['params'],
            additionalProperties: false,
        },
    },
    {
        name: 'identity_Invitations_resend',
        description: 'Re-send the invitation email with a fresh temporary password.',
        context: 'identity',
        operationId: 'Invitations_resend',
        method: 'POST',
        path: '/invitations/{invitationId}/resend',
        action: 'invitation:resend',
        auth: 'tenant',
        inputSchema: {
            type: 'object',
            properties: {
                params: {
                    type: 'object',
                    properties: {
                        invitationId: {
                            type: 'string',
                            pattern: '^[0-9A-HJKMNP-TV-Z]{26}$',
                            description: 'ULID-style opaque identifier for records.',
                        },
                    },
                    required: ['invitationId'],
                    additionalProperties: false,
                },
            },
            required: ['params'],
            additionalProperties: false,
        },
    },
    {
        name: 'identity_Invitations_revoke',
        description: 'Revoke a pending invitation.',
        context: 'identity',
        operationId: 'Invitations_revoke',
        method: 'POST',
        path: '/invitations/{invitationId}/revoke',
        action: 'invitation:revoke',
        auth: 'tenant',
        inputSchema: {
            type: 'object',
            properties: {
                params: {
                    type: 'object',
                    properties: {
                        invitationId: {
                            type: 'string',
                            pattern: '^[0-9A-HJKMNP-TV-Z]{26}$',
                            description: 'ULID-style opaque identifier for records.',
                        },
                    },
                    required: ['invitationId'],
                    additionalProperties: false,
                },
            },
            required: ['params'],
            additionalProperties: false,
        },
    },
    {
        name: 'identity_Self_get',
        description: 'Who is calling, and under which membership.',
        context: 'identity',
        operationId: 'Self_get',
        method: 'GET',
        path: '/me',
        action: 'me:read',
        auth: 'tenant',
        inputSchema: {
            type: 'object',
            properties: {},
            required: [],
            additionalProperties: false,
        },
    },
    {
        name: 'identity_Self_memberships',
        description: 'Every tenant the caller belongs to. Cross-tenant by nature; each row is scoped to its own tenant.',
        context: 'identity',
        operationId: 'Self_memberships',
        method: 'GET',
        path: '/me/memberships',
        action: 'me:read',
        auth: 'tenant',
        inputSchema: {
            type: 'object',
            properties: {},
            required: [],
            additionalProperties: false,
        },
    },
    {
        name: 'identity_Members_list',
        description: "Members of the caller's tenant.",
        context: 'identity',
        operationId: 'Members_list',
        method: 'GET',
        path: '/members',
        action: 'membership:list',
        auth: 'tenant',
        inputSchema: {
            type: 'object',
            properties: {
                query: {
                    type: 'object',
                    properties: {
                        cursor: {
                            type: 'string',
                        },
                        limit: {
                            type: 'integer',
                            format: 'int32',
                            minimum: 1,
                            maximum: 200,
                            default: 50,
                        },
                    },
                    required: [],
                    additionalProperties: false,
                },
            },
            required: [],
            additionalProperties: false,
        },
    },
    {
        name: 'identity_Members_remove',
        description: 'Remove a member from the tenant. Their identity is untouched elsewhere.',
        context: 'identity',
        operationId: 'Members_remove',
        method: 'DELETE',
        path: '/members/{sub}',
        action: 'membership:remove',
        auth: 'tenant',
        inputSchema: {
            type: 'object',
            properties: {
                params: {
                    type: 'object',
                    properties: {
                        sub: {
                            type: 'string',
                            minLength: 1,
                            maxLength: 128,
                            description: "Cognito subject (the identity's stable id).",
                        },
                    },
                    required: ['sub'],
                    additionalProperties: false,
                },
            },
            required: ['params'],
            additionalProperties: false,
        },
    },
    {
        name: 'identity_Members_get',
        description: "One member of the caller's tenant.",
        context: 'identity',
        operationId: 'Members_get',
        method: 'GET',
        path: '/members/{sub}',
        action: 'membership:read',
        auth: 'tenant',
        inputSchema: {
            type: 'object',
            properties: {
                params: {
                    type: 'object',
                    properties: {
                        sub: {
                            type: 'string',
                            minLength: 1,
                            maxLength: 128,
                            description: "Cognito subject (the identity's stable id).",
                        },
                    },
                    required: ['sub'],
                    additionalProperties: false,
                },
            },
            required: ['params'],
            additionalProperties: false,
        },
    },
    {
        name: 'identity_Members_update',
        description: "Change a member's roles, office, agent code or grants.",
        context: 'identity',
        operationId: 'Members_update',
        method: 'PATCH',
        path: '/members/{sub}',
        action: 'membership:update',
        auth: 'tenant',
        inputSchema: {
            type: 'object',
            properties: {
                params: {
                    type: 'object',
                    properties: {
                        sub: {
                            type: 'string',
                            minLength: 1,
                            maxLength: 128,
                            description: "Cognito subject (the identity's stable id).",
                        },
                    },
                    required: ['sub'],
                    additionalProperties: false,
                },
                body: {
                    type: 'object',
                    properties: {
                        roles: {
                            type: 'array',
                            items: {
                                type: 'string',
                                enum: ['PlatformAdmin', 'TenantAdmin', 'Manager', 'Agent'],
                                description: 'Roles as carried in the JWT `cognito:groups` claim and the memberships table.',
                            },
                        },
                        officeCode: {
                            type: 'string',
                            pattern: '^[A-Z0-9][A-Z0-9-]{0,31}$',
                            description: 'Office code inside a tenant.',
                        },
                        agentCode: {
                            type: 'string',
                            pattern: '^[A-Z0-9][A-Z0-9-]{0,31}$',
                            description: 'Agent code inside a tenant.',
                        },
                        grants: {
                            type: 'array',
                            items: {
                                type: 'string',
                            },
                        },
                    },
                },
            },
            required: ['params', 'body'],
            additionalProperties: false,
        },
    },
];
//# sourceMappingURL=tools.js.map